import { FC, memo, type ReactNode } from 'react'
import classNames from 'classnames'

import type { ButtonProps } from './button.interface'
import classes from './button.module.scss'

const Loader = memo(({ label }: { label: ReactNode }) => (
  <div className={classes.loaderWrapper}>
    <div className={classes.loader}>{label}</div>
  </div>
))

Loader.displayName = 'Loader'

export const Button: FC<ButtonProps> = memo(
  ({ variant = 'primary', widthType, children, className, isLoading, loadingLabel, ...props }) => {
    return (
      <button
        className={classNames(
          classes.root,
          {
            [classes.primary]: variant === 'primary',
            [classes.secondary]: variant === 'secondary',
            [classes.danger]: variant === 'danger',
            [classes.withBorder]: variant === 'withBorder',
            [classes.dangerOutline]: variant === 'danger-outline',
            [classes.content]: widthType === 'content',
            [classes.contentCenter]: isLoading,
          },
          className,
        )}
        {...props}
      >
        {isLoading ? <Loader label={loadingLabel ?? 'Loading...'} /> : children}
      </button>
    )
  },
)

Button.displayName = 'Button'
